import axios, { AxiosInstance } from 'axios';

export interface PrivacyPolicyResponse {
  results: {
    id: number;
    file: string;
  }[];
}

const BACKEND_URL = process.env.BACKEND_URL;

export class APIPrivacyPolicy {
  constructor(
    private _axios: AxiosInstance = axios.create({ baseURL: BACKEND_URL }),
  ) {}

  getLink = async (): Promise<string> => {
    const response = await this._axios.get<PrivacyPolicyResponse>(
      `/api/privacy-policy/`,
    );

    // @ts-ignore
    const link = response.data.results[0]?.file;

    if (!link) {
      const msg =
        'Не удалось получить ссылку для просмотра политика конфиденциальности';

      throw new Error(msg);
    }

    return link;
  };
}
